import {
  DisclaimerAPIResponse,
  SendConsentLinkInput,
  SendConsentLinkRes,
} from '@/types/disclaimer';
import { toCamelCaseObj } from '@/utils/transformers';
import {
  DisclaimerEndpoints,
  disclaimerFetcher,
  userPortfolioFetcher,
} from './fetchers';

export async function getDisclaimer({
  broker,
  userId,
  userType,
}: {
  broker: string;
  userId: string;
  userType: string;
}) {
  const response = await disclaimerFetcher.post<DisclaimerAPIResponse>(
    DisclaimerEndpoints.getDisclaimer(broker),
    {
      user_id: userId,
      user_type: userType,
    },
  );
  return toCamelCaseObj(response.data);
}

export async function acceptDisclaimer({
  broker,
  userId,
  disclaimerAccepted,
}: {
  broker: string;
  userId: string;
  disclaimerAccepted: boolean;
}) {
  const response = await disclaimerFetcher.post<DisclaimerAPIResponse>(
    DisclaimerEndpoints.acceptDisclaimer(broker),
    {
      user_id: userId,
      disclaimer_accepted: disclaimerAccepted,
    },
  );
  return toCamelCaseObj(response.data);
}

export async function sendConsentLink(payload: SendConsentLinkInput) {
  const response = await userPortfolioFetcher.post<SendConsentLinkRes>(
    DisclaimerEndpoints.sendConsentLink,
    {
      consent_url: payload.consentUrl,
      whatsapp_template: payload.whatsappTemplate,
    },
  );
  return toCamelCaseObj(response.data);
}
